import React, { useState } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import type { User } from '@/types'
import styles from './Layout.module.css'

interface LayoutProps {
  user: User | null
  children: React.ReactNode
}

export function Layout({ user, children }: LayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <div className={styles.layout}>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <Sidebar
        user={user}
        isMobileMenuOpen={isMobileMenuOpen}
        onCloseMobileMenu={closeMobileMenu}
      />
      <div className={styles.contentWrapper}>
        <Header
          user={user}
          onToggleMobileMenu={toggleMobileMenu}
        />
        <main id="main-content" className={styles.main}>
          <div className={styles.mainInner}>
            {children}
          </div>
        </main>
      </div>
      
      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div 
          className={styles.mobileOverlay}
          onClick={closeMobileMenu}
        />
      )}
    </div>
  )
}